import React from 'react';

import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListItem from '@material-ui/core/ListItem';

const NavItem = ({title, icon, to, component, exact, onClick}) => {
  return (
    <ListItem button component={component} to={to} className="sidebar-menu__item" exact={exact} onClick={onClick}>
      <ListItemIcon title={title} className={`sidebar-menu__icon icon-light-${icon}`}/>
      <ListItemText primary={title} className="sidebar-menu__text"/>
    </ListItem>
  );
};

export default NavItem;
